import store from './../store'

export default {
  path: '/trades',
  name: 'trades',
  redirect: { name: 'trades.list-page' },
  component: () => import('@/views/trades/index.vue'),
  children: [
    {
      path: '/trades',
      name: 'trades.list-page',
      component: () => import('@/views/trades/ListPage.vue'),
    },
  ],
  beforeEnter: async (to, from, next) => {
    if (store.state.auth.user) {
      if (store.state.auth.user.user_type !== 'business_admin')
        next({ name: 'page-not-found' })

      next()
    } else {
      store
        .dispatch('auth/getAuthenticatedUser')
        .then(() => {
          if (store.state.auth.user.user_type !== 'business_admin')
            next({ name: 'page-not-found' })
        })
        .catch(() => next({ name: 'auth.login-page' }))
        .finally(() => next())
    }
  },
}
